import Vue from "vue";
import Router from "vue-router";
import home from "_/index/home";

Vue.use(Router);

const Route = [
  // {
  //   path: "/test", // 方便测试功能
  //   name: "testPage",
  //   // redirect: '/deviceManage/pointCheck',
  //   component: resolve => require(["../views/testPage/index"], resolve)
  // },
  {
    path: "/cockpit", // 驾驶舱全屏，单独显示，测试用
    name: "cockpitPage",
    component: resolve => require(["../views/backGround/cockpit/cockpit"], resolve),
    meta: {
      title: "驾驶舱",
    },
  },
  {
    path: "/testScreen", // 测试设备屏幕的分辨率，用的时候打开注释
    name: "testScreen",
    component: resolve => require(["../views/testPage/testScreen"], resolve),
  },
  {
    path: "/scanCode", // 餐厅核销
    name: "scanCode",
    component: resolve => require(["../views/scanCode/scanCode"], resolve),
  },
  {
    path: "/", // 首页页面
    component: home, // 首页容器`
    // redirect: '/home/login',
    children: [
      {
        path: "/", // 登录页面
        name: "login",
        component: resolve => require(["../views/index/login"], resolve),
      },
      {
        path: "/padIndex", // 平板首页
        name: "padIndex",
        component: resolve => require(["../views/padView/padIndex"], resolve),
      },
      {
        path: "/padEntryNew", // 平板穿纱变更后
        name: "padEntryNew",
        component: resolve => require(["../views/padView/padEntryNew"], resolve),
      },
      {
        path: "/padChangeMachineNew", // 平板改机变更后
        name: "padChangeMachineNew",
        component: resolve => require(["../views/padView/padChangeMachineNew"], resolve),
      },
      {
        path: "/padBulkNew", // 平板量产变更后
        name: "padBulkNew",
        component: resolve => require(["../views/padView/padBulkNew"], resolve),
      },
      {
        path: "/padEntryDetail", // 平板任务单详情变更后
        name: "padEntryDetail",
        component: resolve => require(["../views/padView/padEntryDetail"], resolve),
      },
      {
        path: "/padBulkDetailNew", // 平板量产任务单详情变更后
        name: "padBulkDetailNew",
        component: resolve => require(["../views/padView/padBulkDetailNew"], resolve),
      },
      {
        path: "/padEntry", // 平板穿纱
        name: "padEntry",
        component: resolve => require(["../views/padView/padEntry"], resolve),
      },
      {
        path: "/padBulk", // 平板查看量产
        name: "padBulk",
        component: resolve => require(["../views/padView/padBulk"], resolve),
      },
      {
        path: "/padMs", // 平板故障报修
        name: "padMs",
        component: resolve => require(["../views/padView/padMs"], resolve),
      },
      {
        path: "/padBm", // 平板故障报修
        name: "padBm",
        component: resolve => require(["../views/padView/padBm"], resolve),
      },
      {
        path: "/padRecord", // 平板维修记录
        name: "padRecord",
        component: resolve => require(["../views/padView/padRecord"], resolve),
      },
      {
        path: "/padChangeMachine", // 平板穿纱
        name: "padChangeMachine",
        component: resolve => require(["../views/padView/padChangeMachine"], resolve),
      },
    ],
  },
  {
    path: "/index/backend", // 后台页面容器
    name: "backend",
    component: resolve => require(["../views/backGround/backend"], resolve),
    children: [
      {
        path: "/cockpit/cockpitsign", // 驾驶舱
        name: "cockpitsign",
        component: resolve =>
          require(["../views/backGround/cockpit/cockpitsign.vue"], resolve),
        meta: {
          title: "驾驶舱配置",
        },
      },
      {
        path: "/cockpit/cockpit", // 驾驶舱
        name: "cockpit",
        component: resolve => require(["../views/backGround/cockpit/cockpit"], resolve),
        meta: {
          title: "驾驶舱",
        },
      },
      {
        path: "/account", // 账号详情页
        name: "account",
        component: resolve => require(["../views/backGround/account/account"], resolve),
        meta: {
          title: "账号信息",
        },
      },
      {
        path: "/example", // 页面物料库
        name: "example",
        component: resolve => require(["~/serviceProvider/providerList"], resolve),
        meta: {
          title: "页面物料库",
          affix: true,
          noCache: true,
        },
      },
      {
        path: "/index", // 登录后首页
        name: "index",
        component: resolve => require(["../views/backGround/index"], resolve),
        meta: {
          title: "首页",
          affix: true,
        },
      },
      // 工单管理
      // 生产工单
      {
        path: "/workOrderManage/productOrder",
        name: "productTrick",
        component: resolve =>
          require(["../views/backGround/workOrderManage/productOrder"], resolve),
        meta: {
          title: "生产工单",
          keepAlive: true,
        },
      },
      // 生产工单 详情 (old)
      // {
      //   path: "/workOrderManage/workOrderDetail",
      //   name: "productTrickDetail",
      //   component: resolve =>
      //     require([
      //       "../views/backGround/workOrderManage/workOrderDetail"
      //     ], resolve),
      //   meta: {
      //     title: "工单详情"
      //   }
      // },
      // 生产工单 详情 (new)
      {
        path: "/workOrderManage/workOrderDetail",
        name: "productTrickDetail",
        component: resolve =>
          require(["../views/backGround/workOrderManage/workOrderDetail"], resolve),
        meta: {
          title: "工单详情",
        },
      },
      // 排产计划
      {
        path: "/workOrderManage/productPlan",
        name: "productPlan",
        component: resolve =>
          require(["../views/backGround/workOrderManage/productPlan"], resolve),
        meta: {
          title: "排产计划",
          keepAlive: true,
        },
      },
      // 整经列表
      {
        path: "/workOrderManage/warpListing",
        name: "warpListing",
        component: resolve =>
          require([
            "../views/backGround/workOrderManage/warpListing/warpListing",
          ], resolve),
        meta: {
          title: "整经列表11",
          keepAlive: true,
        },
      },
      // 整经计划
      {
        path: "/workOrderManage/wrapPlan",
        name: "wrapPlan",
        component: resolve =>
          require(["../views/backGround/workOrderManage/wrapPlan"], resolve),
        meta: {
          title: "整经计划",
          keepAlive: true,
        },
      },
      // 整经派工
      {
        path: "/workOrderManage/warpingDispatch",
        name: "warpingDispatch",
        component: resolve =>
          require(["../views/backGround/workOrderManage/warpingDispatch"], resolve),
        meta: {
          title: "整经派工",
          keepAlive: true,
        },
      },
      // 生产工单导入
      {
        path: "/workOrderManage/orderimport",
        name: "orderimport",
        component: resolve =>
          require(["../views/backGround/workOrderManage/orderimport"], resolve),
        meta: {
          title: "生产工单导入",
        },
      },
      // 生产执行
      {
        path: "/productExecute/productExecute", // 生产执行
        name: "productExecute",
        component: resolve =>
          require(["../views/backGround/productExecute/productExecute"], resolve),
        meta: {
          title: "生产执行",
        },
      },
      // 生产派工
      {
        path: "/productExecute/dispatch", // 生产派工
        name: "dispatch",
        component: resolve =>
          require(["../views/backGround/productExecute/dispatch"], resolve),
        meta: {
          title: "生产派工",
        },
      },
      // 改机领单
      {
        path: "/productExecute/dispatchCopy", // 改机领单
        name: "dispatchCopy",
        component: resolve =>
          require(["../views/backGround/productExecute/dispatchCopy"], resolve),
        meta: {
          title: "改机领单",
        },
      },
      // 量产派工
      {
        path: "/productExecute/outputDispatch", // 量产派工
        name: "outputDispatch",
        component: resolve =>
          require(["../views/backGround/productExecute/outputDispatch"], resolve),
        meta: {
          title: "量产派工",
        },
      },
      {
        path: "/productExecute/entry", // 穿纱
        name: "entry",
        component: resolve =>
          require(["../views/backGround/productExecute/entry"], resolve),
        meta: {
          title: "穿纱",
        },
      },
      {
        path: "/productExecute/changeMachine", // 改机
        name: "changeMachine",
        component: resolve =>
          require(["../views/backGround/productExecute/changeMachine"], resolve),
        meta: {
          title: "改机",
        },
      },
      {
        path: "/productExecute/firstInspection", // 首检
        name: "firstInspection",
        component: resolve =>
          require(["../views/backGround/productExecute/firstInspection"], resolve),
        meta: {
          title: "首检",
          keepAlive: true,
        },
      },
      {
        path: "/productExecute/firstInspectionDetail", // 待首检详情
        name: "firstInspectionDetail",
        component: resolve =>
          require(["../views/backGround/productExecute/firstInspectionDetail"], resolve),
        meta: {
          title: "首检详情",
          keepAlive: true,
        },
      },
      {
        path: "/productExecute/firstInspectionFinishedDetail", // 已首检详情
        name: "firstInspectionFinishedDetail",
        component: resolve =>
          require([
            "../views/backGround/productExecute/firstInspectionFinishedDetail",
          ], resolve),
        meta: {
          title: "已首检详情",
        },
      },
      {
        path: "/productExecute/bulk", // 批量生产
        name: "bulk",
        component: resolve =>
          require(["../views/backGround/productExecute/bulk"], resolve),
        meta: {
          title: "量产",
          keepAlive: true,
        },
      },
      {
        path: "/productExecute/bulkDetail", // 生产详情
        name: "bulkDetail",
        component: resolve =>
          require(["../views/backGround/productExecute/bulkDetail"], resolve),
        meta: {
          title: "生产详情",
        },
      },
      {
        path: "/productExecute/packingCompleted", // 包装完工
        name: "packingCompleted",
        component: resolve =>
          require(["../views/backGround/productExecute/packingCompleted"], resolve),
        meta: {
          title: "包装",
        },
      },
      {
        path: "/productExecute/packingChecker", // 包装检验
        name: "packingChecker",
        component: resolve =>
          require(["../views/backGround/productExecute/packingChecker"], resolve),
        meta: {
          title: "包装(检验员)",
          keepAlive: true,
        },
      },
      {
        path: "/productExecute/packingStaff", // 包装称重
        name: "packingStaff",
        component: resolve =>
          require(["../views/backGround/productExecute/packingStaff"], resolve),
        meta: {
          title: "包装(挡车工)",
          keepAlive: true,
        },
      },
      // 设备管理
      {
        path: "/deviceManage/check", // 设备台账
        name: "check",
        component: resolve =>
          require(["../views/backGround/deviceManage/check"], resolve),
        meta: {
          title: "设备台账",
        },
      },
      {
        path: "/deviceManage/equipmentMaintenance", // 设备维修
        name: "equipmentMaintenance",
        component: resolve =>
          require(["../views/backGround/deviceManage/equipmentMaintenance"], resolve),
        meta: {
          title: "设备维修",
          keepAlive: true,
        },
      },
      {
        path: "/deviceManage/equipmentMaintenance/detail", // 设备维修详情
        name: "equipmentMaintenanceDetail",
        component: resolve =>
          require([
            "../views/backGround/deviceManage/equipmentMaintenance/detailPage",
          ], resolve),
        meta: {
          title: "设备维修详情",
        },
      },
      // 机台分组
      {
        path: "/deviceManage/machinegroup", // 机台分组
        name: "group",
        component: resolve =>
          require(["../views/backGround/deviceManage/machineGroup"], resolve),
        meta: {
          title: "机台分组",
        },
      },
      // 机台分配
      {
        path: "/deviceManage/machineallocation", // 机台分配
        name: "allocation",
        component: resolve =>
          require(["../views/backGround/deviceManage/machineAllocation"], resolve),
        meta: {
          title: "机台分配",
        },
      },
      // 设备班组
      {
        path: "/deviceManage/equipmentTeam", // 设备班组
        name: "equipmentTeam",
        component: resolve =>
          require(["../views/backGround/deviceManage/equipmentTeam"], resolve),
        meta: {
          title: "设备班组",
        },
      },
      // 设备班组分配
      {
        path: "/deviceManage/equipmentTeamlocation", // 班组分配
        name: "equipmentTeamlocation",
        component: resolve =>
          require(["../views/backGround/deviceManage/equipmentTeamlocation"], resolve),
        meta: {
          title: "班组分配",
        },
      },
      {
        path: "/deviceManage/addcheck", // 新建设备台账
        name: "addcheck",
        component: resolve =>
          require(["../views/backGround/deviceManage/addcheck"], resolve),
        meta: {
          title: "新建设备台账",
        },
      },
      {
        path: "/deviceManage/editcheck", // 编辑设备台账
        name: "editcheck",
        component: resolve =>
          require(["../views/backGround/deviceManage/editcheck"], resolve),
        meta: {
          title: "编辑设备台账",
        },
      },
      {
        path: "/deviceManage/checkdetail", // 设备台账详情
        name: "checkdetail",
        component: resolve =>
          require(["../views/backGround/deviceManage/checkdetail"], resolve),
        meta: {
          title: "设备详情",
        },
      },
      {
        path: "/deviceManage/bulkimport", // 设备台账批量导入
        name: "bulkimport",
        component: resolve =>
          require(["../views/backGround/deviceManage/bulkimport"], resolve),
        meta: {
          title: "设备批量导入",
        },
      },
      {
        path: "/deviceManage/devmaintenance", // 设备保养
        name: "devmaintenance",
        component: resolve =>
          require(["../views/backGround/deviceManage/devmaintenance"], resolve),
        meta: {
          title: "计划保养",
        },
      },
      {
        path: "/deviceManage/addDevmaintenance", // 新增设备保养单
        name: "addDevmaintenance",
        component: resolve =>
          require(["../views/backGround/deviceManage/addDevmaintenance"], resolve),
        meta: {
          title: "新建设备保养单",
        },
      },
      {
        path: "/deviceManage/devmaintenanceDetail", // 查看设备保养单
        name: "devmaintenanceDetail",
        component: resolve =>
          require(["../views/backGround/deviceManage/devmaintenanceDetail"], resolve),
        meta: {
          title: "查看设备保养单",
        },
      },
      {
        path: "/deviceManage/maintaining", // 实施保养
        name: "maintaining",
        component: resolve =>
          require(["../views/backGround/deviceManage/maintaining"], resolve),
        meta: {
          title: "实施保养",
        },
      },
      {
        path: "/deviceManage/maintainingDetail", // 查看实施保养
        name: "maintainingDetail",
        component: resolve =>
          require(["../views/backGround/deviceManage/maintainingDetail"], resolve),
        meta: {
          title: "查看实施保养",
        },
      },

      // 班次修改
      {
        path: "/deviceManage/ShiftModification", // 班次修改
        name: "ShiftModification",
        component: resolve =>
          require(["../views/backGround/deviceManage/ShiftModification"], resolve),
        meta: {
          title: "班次修改",
        },
      },
      // 设备配置信息
      {
        path: "/deviceManage/DeviceConfiguration", // 设备配置信息
        name: "DeviceConfiguration",
        component: resolve =>
          require(["../views/backGround/deviceManage/DeviceConfiguration"], resolve),
        meta: {
          title: "设备配置信息",
        },
      },
      {
        path: "/deviceManage/addMaintaining", // 填写实施保养
        name: "addMaintaining",
        component: resolve =>
          require(["../views/backGround/deviceManage/addMaintaining"], resolve),
        meta: {
          title: "填写实施保养单",
        },
      },
      // 点检报表
      {
        path: "/deviceManage/pointCheckReport",
        name: "pointCheckReport",
        component: resolve =>
          require(["../views/backGround/deviceManage/pointCheck"], resolve),
        meta: {
          title: "点检报表",
          keepAlive: true,
        },
      },
      // 点检项目配置页
      {
        path: "/deviceManage/pointCheckConfig",
        name: "pointCheckConfig",
        component: resolve =>
          require([
            "../views/backGround/deviceManage/pointCheck/pointCheckConfig",
          ], resolve),
        meta: {
          title: "点检项配置",
        },
      },
      //生产监控
      {
        path: "/productionControl/deviceControl", // 设备监控
        name: "deviceControl",
        component: resolve =>
          require(["../views/backGround/productionControl/deviceControl"], resolve),
        meta: {
          title: "设备监控",
        },
      },
      {
        path: "/productionControl/orderControl", // 工单监控
        name: "orderControl",
        component: resolve =>
          require(["../views/backGround/productionControl/orderControl"], resolve),
        meta: {
          title: "工单监控",
        },
      },
      {
        path: "/productionControl/formMonitoring", // 车间监控
        name: "formMonitoring",
        component: resolve =>
          require(["../views/backGround/productionControl/formMonitoring"], resolve),
        meta: {
          title: "车间监控",
        },
      },
      {
        path: "/productionControl/workshopMonitoring", // 车间监控1
        name: "workshopMonitoring",
        component: resolve =>
          require(["../views/backGround/productionControl/workshopMonitoring"], resolve),
        meta: {
          title: "设备看板",
        },
      },
      // {
      //   path: "/productionControl/gatherWorkTime",//采集工时
      //   name: "gatherWorkTime",
      //   component: resolve =>
      //     require([
      //       "../views/backGround/productionControl/gatherWorkTime"
      //     ], resolve),
      //   meta: {
      //     title: "采集工时"
      //   }
      // },
      {
        path: "/productionMonitoring/abnormalMonitoring", // 异常监控
        name: "abnormalMonitoring",
        component: resolve =>
          require([
            "../views/backGround/productionMonitoring/abnormalMonitoring",
          ], resolve),
        meta: {
          title: "异常监控",
        },
      },
      {
        path: "/productionControl/workshopdetail", // 车间监控详情
        name: "workshopdetail",
        component: resolve =>
          require(["../views/backGround/productionControl/workshopdetail"], resolve),
        meta: {
          title: "车间监控详情",
        },
      },
      {
        path: "/deviceManage/record", // 设备故障记录
        name: "deviceRecord",
        component: resolve =>
          require(["../views/backGround/deviceManage/record"], resolve),
        meta: {
          title: "设备故障",
        },
      },
      {
        path: "/deviceManage/devMaintainRecord", // 设备保养
        name: "devMaintainRecord",
        component: resolve =>
          require(["../views/backGround/deviceManage/devMaintence"], resolve),
        meta: {
          title: "设备保养",
        },
      },
      {
        path: "/deviceManage/devMaintainRecord/maintainConfiguration", // 保养配置
        name: "maintainConfiguration",
        component: resolve =>
          require([
            "../views/backGround/deviceManage/devMaintence/maintainConfiguration",
          ], resolve),
        meta: {
          title: "保养项配置",
        },
      },
      {
        path: "/deviceManage/devMaintainRecord/createMaintain", // 新建保养计划
        name: "createMaintain",
        component: resolve =>
          require([
            "../views/backGround/deviceManage/devMaintence/createMaintain",
          ], resolve),
        meta: {
          title: "新建保养计划",
        },
      },
      {
        path: "/deviceManage/devMaintainRecord/maintainDetail", // 保养详情(未下发)
        name: "maintainDetail",
        component: resolve =>
          require([
            "../views/backGround/deviceManage/devMaintence/maintainDetail",
          ], resolve),
        meta: {
          title: "保养详情",
        },
      },
      {
        path: "/deviceManage/devMaintainRecord/maintainFinished", // 保养详情(已下发)
        name: "maintainFinished",
        component: resolve =>
          require([
            "../views/backGround/deviceManage/devMaintence/maintainFinished",
          ], resolve),
        meta: {
          title: "保养详情(已下发)",
        },
      },
      {
        path: "/deviceManage/maintainReport", // 保养报表
        name: "maintainReport",
        component: resolve =>
          require(["../views/backGround/deviceManage/maintainReport"], resolve),
        meta: {
          title: "保养报表",
        },
      },
      {
        path: "/deviceManage/recordDetail", // 设备故障记录
        name: "recordDetail",
        component: resolve =>
          require(["../views/backGround/deviceManage/recordDetail"], resolve),
        meta: {
          title: "故障详情",
        },
      },
      // 工时统计报表2020.06.17添加
      // {
      //     path: '/statistics/manhourReport', // 工时统计报表
      //     name: 'manhourReport',
      //     component: resolve => require(['../views/backGround/statisticsChart/manhourReport'], resolve),
      //     meta: {
      //         title: '工时统计报表'
      //     }
      // },
      // 统计报表
      {
        path: "/statistics/productReport", // 生产报表
        name: "productReport",
        component: resolve =>
          require(["../views/backGround/statisticsChart/productReport"], resolve),
        meta: {
          title: "生产报表",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/effectiveness", // 设备利用率偏差报表
        name: "effectiveness",
        component: resolve =>
          require(["../views/backGround/statisticsChart/effective"], resolve),
        meta: {
          title: "设备利用率报表",
        },
      },
      {
        path: "/statistics/openTimes", // 开机工时报表
        name: "openTimes",
        component: resolve =>
          require(["../views/backGround/statisticsChart/openTimes"], resolve),
        meta: {
          title: "开机报表",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/openTimesSearch", // 开机时间查询
        name: "openTimesSearch",
        component: resolve =>
          require(["../views/backGround/statisticsChart/openTimesSearch"], resolve),
        meta: {
          title: "开机时间查询",
        },
      },
      // {
      //   path: "/statistics/textileReport", // 穿纱改机人员报表（隐藏掉），已拆成2个页面（穿纱报表和改机报表）
      //   name: "textileReport",
      //   component: resolve =>
      //     require([
      //       "../views/backGround/statisticsChart/textileReport"
      //     ], resolve),
      //   meta: {
      //     title: "工序报表",
      //     keepAlive: true
      //   }
      // },
      {
        path: "/statistics/wrapTaskReport", // 整经任务单
        name: "WrapTaskReport",
        component: resolve =>
          require(["../views/backGround/statisticsChart/wrapTaskReport"], resolve),
        meta: {
          title: "整经任务单",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/wrapDispatchingReport", // 整经派工表
        name: "WrapDispatchingReport",
        component: resolve =>
          require(["../views/backGround/statisticsChart/wrapDispatchingReport"], resolve),
        meta: {
          title: "整经派工表",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/wrapWorkReport", // 整经报工表
        name: "WrapWorkReport",
        component: resolve =>
          require(["../views/backGround/statisticsChart/wrapWorkReport"], resolve),
        meta: {
          title: "整经报工表",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/threadingReport", // 穿纱报表
        name: "ThreadingReport",
        component: resolve =>
          require(["../views/backGround/statisticsChart/threadingReport"], resolve),
        meta: {
          title: "穿纱报表",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/batchProcessing", // 批量处理
        name: "batchProcessing",
        component: resolve =>
          require([
            "../views/backGround/statisticsChart/batchProcessing/batchProcessing",
          ], resolve),
        meta: {
          title: "批量处理",
          // keepAlive: true,
        },
      },
      {
        path: "/statistics/batchProcessingDe", // 批量处理详情
        name: "batchProcessingDe",
        component: resolve =>
          require([
            "../views/backGround/statisticsChart/batchProcessing/batchProcessingDe",
          ], resolve),
        meta: {
          title: "批量处理详情",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/workOrderScrap", // 批量处理
        name: "workOrderScrap",
        component: resolve =>
          require([
            "../views/backGround/statisticsChart/workOrderScrap/workOrderScrap",
          ], resolve),
        meta: {
          title: "工单废品率",
          // keepAlive: true,
        },
      },
      {
        path: "/statistics/unfinishedChangeMachine", // 改机报表(未完成)
        name: "UnfinishedChangeMachine",
        component: resolve =>
          require([
            "../views/backGround/statisticsChart/unfinishedChangeMachine",
          ], resolve),
        meta: {
          title: "改机报表(未完成)",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/finishedChangeMachine", // 改机报表(已完成)
        name: "finishedChangeMachine",
        component: resolve =>
          require(["../views/backGround/statisticsChart/finishedChangeMachine"], resolve),
        meta: {
          title: "改机报表(已完成)",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/houdaokaiji", // 后道开机报表
        name: "houdaokaiji",
        component: resolve =>
          require(["../views/backGround/statisticsChart/houdaokaiji"], resolve),
        meta: {
          title: "后道开机报表",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/shutdownReport", // 下机报表
        name: "shutdownReport",
        component: resolve =>
          require(["../views/backGround/statisticsChart/shutdownReport"], resolve),
        meta: {
          title: "下机报表",
        },
      },
      {
        path: "/statistics/packingCheck", // 包装检验
        name: "packingCheck",
        component: resolve =>
          require(["../views/backGround/statisticsChart/packingCheck"], resolve),
        meta: {
          title: "包装",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/changeMachineDelay", // 改机延迟异常报表
        name: "changeMachineDelay",
        component: resolve =>
          require(["../views/backGround/statisticsChart/changeMachineDelay"], resolve),
        meta: {
          title: "改机延迟异常报表",
        },
      },
      {
        path: "/statistics/workTimeTable", // 工时报表
        name: "workTimeTable",
        component: resolve =>
          require(["../views/backGround/statisticsChart/workTimeTable"], resolve),
        meta: {
          title: "工时报表",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/completionRate", // 入库完成率
        name: "completionRate",
        component: resolve =>
          require(["../views/backGround/statisticsChart/completionRate"], resolve),
        meta: {
          title: "入库完成率",
        },
      },
      {
        path: "/statistics/report", // 量产报工
        name: "report",
        component: resolve =>
          require(["../views/backGround/statisticsChart/report"], resolve),
        meta: {
          title: "量产报工",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/cardReplacement", // 量产补卡
        name: "cardReplacement",
        component: resolve =>
          require(["../views/backGround/statisticsChart/cardReplacement"], resolve),
        meta: {
          title: "量产补卡",
        },
      },
      {
        path: "/statistics/productErrorform", // 生产异常报表
        name: "productErrorform",
        component: resolve =>
          require(["../views/backGround/statisticsChart/productErrorform"], resolve),
        meta: {
          title: "生产异常报表",
        },
      },
      {
        path: "/statistics/onSiteInspection", // 巡检报表
        name: "onSiteInspection",
        component: resolve =>
          require(["../views/backGround/statisticsChart/onSiteInspection"], resolve),
        meta: {
          title: "巡检报表",
          keepAlive: true,
        },
      },
      {
        path: "/statistics/exceptionTypeManage", // 异常类型管理
        name: "exceptionTypeManage",
        component: resolve =>
          require(["../views/backGround/statisticsChart/exceptionTypeManage"], resolve),
        meta: {
          title: "异常类型",
        },
      },
      // 系统管理
      {
        path: "/systemManagement/organizational", // 组织架构
        name: "organizational",
        component: resolve =>
          require(["../views/backGround/systemManage/organizational"], resolve),
        meta: {
          title: "组织架构",
        },
      },
      {
        path: "/systemManagement/department", // 车间管理
        name: "department",
        component: resolve =>
          require(["../views/backGround/systemManage/department"], resolve),
        meta: {
          title: "车间管理",
        },
      },
      {
        path: "/systemManagement/authority", // 权限管理
        name: "authority",
        component: resolve =>
          require(["../views/backGround/systemManage/authorityManage"], resolve),
        meta: {
          title: "权限管理",
        },
      },
      {
        path: "/systemManagement/scheduling", // 排班设置
        name: "scheduling",
        component: resolve =>
          require(["../views/backGround/systemManage/schedulingSetting"], resolve),
        meta: {
          title: "排班设置",
        },
      },
      {
        path: "/systemManagement/materialBox", // 料箱管理
        name: "materialBox",
        component: resolve =>
          require(["../views/backGround/systemManage/materialBox"], resolve),
        meta: {
          title: "料箱管理",
        },
      },
      {
        path: "/systemManagement/modelManage", // 型号管理
        name: "modelManage",
        component: resolve =>
          require(["../views/backGround/systemManage/modelManage"], resolve),
        meta: {
          title: "型号管理",
        },
      },
      {
        path: "/systemManagement/addRole", // 新建权限管理角色
        name: "addRole",
        component: resolve =>
          require(["../views/backGround/systemManage/addRole"], resolve),
        meta: {
          title: "新建/编辑角色",
        },
      },
      // 串口配置
      {
        path: "/adminPage/padManage", // 工位平板情况
        name: "padManage",
        component: resolve => require(["../views/backGround/admin/padManage"], resolve),
        meta: {
          title: "工位电脑管理",
        },
      },
      {
        path: "/adminPage/padManageDetail", // 工位平板详情
        name: "padManageDetail",
        component: resolve =>
          require(["../views/backGround/admin/padManageDetail"], resolve),
        meta: {
          title: "工位电脑详情",
        },
      },
      {
        path: "/adminPage/childSerial", // 子串口详情
        name: "childSerial",
        component: resolve => require(["../views/backGround/admin/childSerial"], resolve),
        meta: {
          title: "子串口详情",
        },
      },
      {
        path: "/productionMonitoring/devMonitoring", // 设备监控
        name: "devMonitoring",
        component: resolve =>
          require(["../views/backGround/productionMonitoring/devMonitoring"], resolve),
        meta: {
          title: "设备监控",
        },
      },
      {
        path: "/productionMonitoring/orderMonitoring", // 工单监控
        name: "orderMonitoring",
        component: resolve =>
          require(["../views/backGround/productionMonitoring/orderMonitoring"], resolve),
        meta: {
          title: "工单监控",
        },
      },
      {
        path: "/productionMonitoring/workshopBoard", // 车间看板
        name: "workshopBoard",
        component: resolve =>
          require(["../views/backGround/productionMonitoring/workshopBoard"], resolve),
        meta: {
          title: "车间看板",
        },
      },
      {
        path: " http://223.93.68.147:30007/houdao/deviceMonitoring", // 工单监控
        name: "neworderMonitoring",
        component: resolve =>
          require([
            "../views/backGround/productionMonitoring/neworderMonitoring",
          ], resolve),
        meta: {
          title: "工单燃尽图",
        },
      },
      {
        path: "/collector/farmMonitoring", // 车间平面图
        name: "farmMonitoring",
        component: resolve =>
          require(["../views/backGround/collector/farmMonitoring"], resolve),
        meta: {
          title: "车间平面图",
        },
      },
      {
        path: "/collector/manage", // 采集器管理
        name: "manage",
        component: resolve => require(["../views/backGround/collector/manage"], resolve),
        meta: {
          title: "采集器管理",
        },
      },
      {
        path: "/shape/shape", // 采集器管理
        name: "shape",
        component: resolve => require(["../views/backGround/shape"], resolve),
        meta: {
          title: "时间轴",
        },
      },
      // 后道工艺路线
      {
        path: "/postProcessing/processRoute",
        name: "processRoute",
        component: resolve =>
          require([
            "../views/backGround/postProcessing/processRoute/processRoute",
          ], resolve),
        meta: {
          title: "后道工艺路线",
          keepAlive: true,
        },
      },
      // 后道生产计划
      {
        path: "/postProcessing/producePlan",
        name: "producePlan",
        component: resolve =>
          require([
            "../views/backGround/postProcessing/producePlan/producePlan",
          ], resolve),
        meta: {
          title: "后道生产计划",
          keepAlive: true,
        },
      },
      // 后道报工单
      {
        path: "/postProcessing/workReportForm",
        name: "workReportForm",
        component: resolve =>
          require([
            "../views/backGround/postProcessing/workReportForm/workReportForm",
          ], resolve),
        meta: {
          title: "后道报工单",
          // keepAlive: true,
        },
      },
      // 餐厅预约
      {
        path: "/statistics/logistics",
        name: "logistics",
        component: resolve =>
          require(["../views/backGround/statisticsChart/logistics/logistics"], resolve),
        meta: {
          title: "餐厅预定",
          keepAlive: true,
        },
      },
      //休假日期
      {
        path: "/statistics/employeeLeaveSchedule",
        name: "employeeLeaveSchedule",
        component: resolve =>
          require(["../views/backGround/statisticsChart/employeeLeaveSchedule/employeeLeaveSchedule"], resolve),
        meta: {
          title: "休假日期表",
          keepAlive: true,
        },
      },
      //包纱工单管理
      {
        path: "/wrappedYarn/schedulingPlan",
        name: "schedulingPlan",
        component: resolve =>
          require(["../views/backGround/wrappedYarn/schedulingPlan"], resolve),
        meta: {
          title: "工单排产",
          keepAlive: true,
        },
      },
      //设备运行状态
      {
        path: "/wrappedYarn/equipmentOperationStatus",
        name: "equipmentOperationStatus",
        component: resolve =>
          require(["../views/backGround/wrappedYarn/equipmentOperationStatus"], resolve),
        meta: {
          title: "设备运行状态",
          keepAlive: true,
        },
      },
      //包纱管理-检验标准
      {
        path: "/wrappedYarn/checkStandard",
        name: "checkStandard",
        component: resolve =>
          require(["../views/backGround/wrappedYarn/checkStandard"], resolve),
        meta: {
          title: "检验标准",
          keepAlive: true,
        },
      },
      //生产执行报表
      {
        path: "/wrappedYarn/productionExecution",
        name: "productionExecution",
        component: resolve =>
          require(["../views/backGround/wrappedYarn/productionExecution"], resolve),
        meta: {
          title: "生产执行",
          keepAlive: true,
        },
      },
      //生产跟踪报表
      {
        path: "/wrappedYarn/productionTrack",
        name: "productionTrack",
        component: resolve =>
          require(["../views/backGround/wrappedYarn/productionTrack"], resolve),
        meta: {
          title: "生产跟踪",
          keepAlive: true,
        },
      },
      //员工工资报表
      {
        path: "/wrappedYarn/EmployeePayroll",
        name: "productionExecution",
        component: resolve =>
          require([
            // "../views/backGround/wrappedYarn/productionTrack",
            "../views/backGround/wrappedYarn/employeePayroll",
          ], resolve),
        meta: {
          title: "员工工资",
          keepAlive: true,
        },
      },
      //产量报表
      {
        path: "/wrappedYarn/productionMass",
        name: "productionMass",
        component: resolve =>
          require(["../views/backGround/wrappedYarn/productionMass"], resolve),
        meta: {
          title: "产量报表",
          keepAlive: true,
        },
      },
      //员工工时报表
      {
        path: "/wrappedYarn/employeeHours",
        name: "employeeHours",
        component: resolve =>
          require(["../views/backGround/wrappedYarn/employeeHours"], resolve),
        meta: {
          title: "员工工时",
          keepAlive: true,
        },
      },
    ],
  },
];

// 配置路由
const router = new Router({
  mode: "history",
  history: true,
  routes: Route,
});

// 全局守卫 控制用户未登录状况下的加载
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(res => res.meta.requireLogin)) { // 判斷是否需要登錄
//     // 判断是否有登录凭证，如果有，正常跳转，没有返回登录页面或主页，并提示
//     if (window.sessionStorage.getItem('')) {
//       // 根据登录时间设置过期时间 8小时
//       let loginTime = parseInt(window.sessionStorage.getItem('tokenTime')) + 1000 * 60 * 8;
//       let nowTime = (new Date()).getTime(); // 获取当前时间
//       if (nowTime < loginTime) {
//         next()
//       } else {
//         // Token 超时
//         Message({
//           showClose: true,
//           message: '登录状态信息过期，请重新登录！',
//           type: 'error'
//         });
//         window.sessionStorage.clear();
//         next({
//           path: '/home/index'
//         })
//       }
//     } else {
//       // 没有登录则跳转到登录页
//       next({
//         path: '/home/login'
//       })
//     }
//   } else {
//     next()
//   }
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js